import React from 'react';
interface IconProps {
  width?: string;
  height?: string;
  fill?: string;
  hover?: boolean;
}

export const EditIcon: React.FC<IconProps> = ({ width = '24px', height = '24px', fill = '#591C48', hover = true }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.2137 1.78407C12.8019 0.375036 10.5158 0.375036 9.10395 1.78407L7.74337 3.14465L1.62101 9.26731C1.50971 9.37845 1.43756 9.52276 1.41542 9.67848L0.734871 14.4403C0.705015 14.6491 0.767219 14.8605 0.905361 15.0198C1.0435 15.1791 1.24398 15.2706 1.45483 15.2705C1.48929 15.2706 1.5237 15.2682 1.55781 15.2633L6.32003 14.5831C6.47571 14.5606 6.61994 14.4883 6.7312 14.3771L14.2144 6.89456C14.8922 6.21691 15.273 5.29774 15.273 4.33932C15.273 3.38089 14.8922 2.46172 14.2144 1.78407H14.2137ZM5.87398 13.1767L2.31199 13.6852L2.82106 10.1236L8.25771 4.68649L11.3111 7.73971L5.87398 13.1767ZM12.3394 6.71082L13.1851 5.86475H13.1854C14.0285 5.02134 14.0285 3.65429 13.1854 2.81088C12.331 1.99558 10.9867 1.99558 10.1323 2.81088L9.28578 3.65746L12.3394 6.71082Z'
        fill='#591C48'
      />
    </svg>
  );
};
